<template>
  <div id="app">
    <notifications></notifications>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    disableRTL() {
      if (!this.$rtl.isRTL) {
        this.$rtl.disableRTL();
      }
    },
    toggleNavOpen() {
      let root = document.getElementsByTagName("html")[0];
      root.classList.toggle("nav-open");
    },
  },
  mounted() {
    this.$watch("$route", this.disableRTL, { immediate: true });
    this.$watch("$sidebar.showSidebar", this.toggleNavOpen);
  },
};
</script>

<style>
.custom-success {
  background-color: #008b00 !important; /* Dark Green */
  border-color: #008b00 !important; /* Dark Green Border */
  color: white !important; /* Text color */
}
.custom-danger {
  background-color: #a50000 !important; /* Dark Green */
  border-color: #a50000 !important; /* Dark Green Border */
  color: white !important; /* Text color */
}
.with-border {
  border-top: 1px solid #e0e0e0; /* Add a light gray border */
}
.el-popconfirm__main {
  color: #a50000 !important;
}
.el-popconfirm__action .el-button--primary {
  background-color: #dd0000 !important; /* Change confirm button color */
  border-color: #dd0000 !important;
  color: white !important;
  font-weight: bold;
}
</style>
